import React, { useEffect, useState } from "react";
import { LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import EngagementSwitcher from "@/components/EngagementSwitcher";

const StatusBar = ({ node = "CSX-CORE-01", session = "AX-8849-DELTA" }) => {
  const { user, logout } = useAuth();
  const [clock, setClock] = useState("");

  useEffect(() => {
    const tick = () =>
      setClock(
        new Date().toLocaleTimeString("en-US", { hour12: false }) +
          " UTC" +
          new Date().toString().match(/([+-]\d{4})/)?.[1]?.slice(0, 3) || ""
      );
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <header
      data-testid="status-bar"
      className="fixed top-0 inset-x-0 h-12 z-50 border-b border-slate-800 bg-slate-950/90 backdrop-blur flex items-center justify-between px-6"
    >
      <div className="flex items-center gap-6">
        <div data-testid="brand-logo" className="font-display text-lg font-black tracking-[0.15em]">
          <span className="text-cyan-400 text-glow-cyan">CYBER</span>
          <span className="text-fuchsia-400 text-glow-pink">SPHERE</span>
          <span className="text-cyan-400 text-glow-cyan"> X</span>
        </div>
        <div className="hidden md:flex items-center gap-2 text-xs">
          <span className="w-2 h-2 rounded-full bg-emerald-400 pulse-dot" />
          <span className="text-emerald-300 tracking-widest">OPERATIONAL</span>
        </div>
      </div>
      <div className="hidden lg:flex items-center gap-8 text-[11px] tracking-widest text-slate-400 uppercase">
        <span>NODE: <span className="text-slate-200">{node}</span></span>
        <span>SESSION: <span className="text-slate-200">{session}</span></span>
        <span data-testid="clock" className="text-cyan-300 tick-shadow">{clock}</span>
      </div>
      <div className="flex items-center gap-3">
        <EngagementSwitcher />
        {user && (
          <>
            <div className="text-right text-xs leading-tight hidden sm:block">
              <div className="text-slate-200" data-testid="user-name">{user.name}</div>
              <div className="text-cyan-400 uppercase tracking-widest text-[10px]" data-testid="user-role">{user.role}</div>
            </div>
            <button
              data-testid="logout-btn"
              onClick={logout}
              className="text-slate-400 hover:text-rose-400 p-1.5 border border-slate-800 hover:border-rose-500/60 transition-all"
              title="Logout"
            >
              <LogOut className="h-4 w-4" />
            </button>
          </>
        )}
      </div>
    </header>
  );
};

export default StatusBar;
